module.exports = __webpack_public_path__ + "assets/img/819515cbe6529a320e24c7b7b65222a9.png";